import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../style/HeroSection.css"; // Используем те же стили для консистентности

export default function ResetPassword() {
  const { token } = useParams(); // Забираем токен из URL
  const navigate = useNavigate();
  
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [status, setStatus] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (newPassword !== confirmPassword) {
      return setStatus({ type: "error", message: "Пароли не совпадают" });
    }

    setLoading(true);
    try {
      const response = await fetch(`https://bilpay.kg/api/reset-password/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ newPassword }),
      });

      const data = await response.json();

      if (data.success) {
        setStatus({ type: "success", message: "Пароль успешно изменен! Перенаправление..." });
        setTimeout(() => navigate("/"), 3000); // Редирект на главную через 3 сек
      } else {
        setStatus({ type: "error", message: data.error || "Произошла ошибка" });
      }
    } catch (err) {
      setStatus({ type: "error", message: "Ошибка подключения к серверу" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hero-wrapper" style={{ justifyContent: "center", alignItems: "center" }}>
      <div className="modal-glass" style={{ width: "100%", maxWidth: "400px" }}>
        <h2 className="modal-title">Новый пароль</h2>
        <p className="modal-subtitle">Введите новый пароль для вашего аккаунта</p>

        <form className="modal-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Придумайте пароль</label>
            <input
              type="password"
              placeholder="Минимум 6 символов"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={6}
            />
          </div>

          <div className="form-group">
            <label>Повторите пароль</label>
            <input
              type="password"
              placeholder="••••••••"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          {status.message && (
            <p style={{ 
              color: status.type === "error" ? "#ef4444" : "#42b693", 
              fontSize: "14px", 
              textAlign: "center",
              marginBottom: "15px" 
            }}>
              {status.message}
            </p>
          )}

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Обновление..." : "Сохранить новый пароль"}
          </button>
        </form>
      </div>
      
      {/* Декор фона чтобы страница не была пустой */}
      <div className="bg-blur blur-1"></div>
      <div className="bg-blur blur-2"></div>
    </div>
  );
}